import "../../../../src/content/goldcoast-streaming/goldcoast.scss";
import * as React from 'react';
export default {
  React
};